import script from "./TriageSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./TriageSelect.vue?vue&type=script&setup=true&lang=ts"

import "./TriageSelect.vue?vue&type=style&index=0&id=19e74788&scoped=true&lang=css"

import exportComponent from "/buddy/uup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e74788"]])

export default __exports__